import React from "react";
import { currentContactColumns, proposedContactGroups, ViewMode } from "../data/navigation";
import { MenuPanel, MenuHeading } from "./MenuPanel";
import { NoteTag } from "./NoteTag";
type ContactMenuProps = {
  view: ViewMode;
  showNotes: boolean;
};
const FAQ = "Frequently Asked Questions";
export function ContactMenu({
  view,
  showNotes
}: ContactMenuProps) {
  if (view === "current") {
    return <MenuPanel data-id="element-2" data-mp="2nxbkt78yl05l">
        <div className="grid grid-cols-[1fr_auto] gap-10 px-9 pt-8" data-id="element-3" data-mp="2nwse6mordy6v">
          {currentContactColumns.map((col, i) => <ul key={i} className="space-y-4" data-id="element-4" data-mp="2sxg0ww5yfsva" data-mpi={i}>
              {col.map(label => <li key={label} className="flex flex-col items-start gap-1" data-id="element-5" data-mp="2e676m9r3xjbt">
                  <a href="#" className="text-[16px] hover:underline" data-id="element-6" data-mp="2j490zqtzh52l">{label}</a>
                  {showNotes && label === FAQ && <NoteTag data-id="element-7" data-mp="36tl8mm9nx52s">Also duplicated in About Us</NoteTag>}
                </li>)}
            </ul>)}
        </div>
      </MenuPanel>;
  }
  return <MenuPanel data-id="element-8" data-mp="3r1rs52ysgl4">
      <div className="grid grid-cols-2 gap-10 px-9 pt-8" data-id="element-9" data-mp="3qi9gn9ejq6k">
        {proposedContactGroups.map(group => <div key={group.heading} data-id="element-10" data-mp="3uy4lb369yyyi">
            <MenuHeading data-id="element-11" data-mp="dfjpgdfy67kj">{group.heading}</MenuHeading>
            {showNotes && group.heading === "For Families" && <NoteTag className="mt-1" data-id="element-12" data-mp="8pd2sj4zwx4x">Grouped by audience</NoteTag>}
            <ul className="mt-4 space-y-4" data-id="element-13" data-mp="8n0dtm0tlmid">
              {group.items.map(label => <li key={label} className="flex flex-col items-start gap-1" data-id="element-14" data-mp="menbnqaev339">
                  <a href="#" className="text-[16px] hover:underline" data-id="element-15" data-mp="hglrf2190xq7">{label}</a>
                  {showNotes && label === FAQ && <NoteTag data-id="element-16" data-mp="we5to16rgeso">Now the only FAQ link</NoteTag>}
                </li>)}
            </ul>
          </div>)}
      </div>
    </MenuPanel>;
}